export default "__VITE_ASSET__58d7fa20__"